import React from "react";
import { useTranslation } from "react-i18next";
import { toggleSheetRewriteOnly } from "../actions";
import { ModalBuilder } from "@redriver/cinnamon";
import { withRouter } from "react-router-dom";
import { withCurrentUser } from "features/../../../shared/components/auth";

import {
  Actions,
  Targets,
} from "features/../../../shared/constants/permissions";
import { TranslatedModal } from "features/../../../shared/components/modals";
import { DropdownItem } from "semantic-ui-react";
import { ImpersonatedUserPermissionCheck } from "modules/ImpersonatedUserPermissions";

const ToggleSheetRewriteOnly = ({ sheet, onSubmitted }) => {
  const { t } = useTranslation("agreements");
  const { sheetId, sheetName, isRewriteOnly } = sheet;
  return (
    <ImpersonatedUserPermissionCheck
      target={Targets.Sheet}
      action={Actions.SetRewriteOnly}
    >
      <ModalBuilder
        withForm
        submitAction={toggleSheetRewriteOnly}
        submitParams={sheetId}
        onSubmitted={onSubmitted}
        renderTrigger={(trigger) => (
          <DropdownItem onClick={trigger}>
            {isRewriteOnly
              ? t("SheetActions.RemoveRewriteOnlySheet.TriggerText")
              : t("SheetActions.RewriteOnlySheet.TriggerText")}
          </DropdownItem>
        )}
        renderModal={(modalProps) => (
          <TranslatedModal.Confirmation
            {...modalProps}
            header={
              isRewriteOnly
                ? t("SheetActions.RemoveRewriteOnlySheet.TriggerText")
                : t("SheetActions.RewriteOnlySheet.TriggerText")
            }
            size="small"
          >
            {isRewriteOnly
              ? t("SheetActions.RemoveRewriteOnlySheet.ConfirmMessage", {
                  sheetName,
                })
              : t("SheetActions.RewriteOnlySheet.ConfirmMessage", {
                  sheetName,
                })}
          </TranslatedModal.Confirmation>
        )}
      />
    </ImpersonatedUserPermissionCheck>
  );
};

export default withCurrentUser(withRouter(ToggleSheetRewriteOnly));
